module.exports = __webpack_public_path__ + "static/logo-62dd5ec9b302dff23d649340852971d3.svg";